import React from "react";
import ReactDOM from "react-dom";
import GeoLocation from "./lib/index";

import "./index.css";

ReactDOM.render(<GeoLocation />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js